import { render } from "./Adder.vue?vue&type=template&id=a1e6ef7e&scoped=true"
import script from "./Adder.vue?vue&type=script&lang=js"
export * from "./Adder.vue?vue&type=script&lang=js"

import "./Adder.vue?vue&type=style&index=0&id=a1e6ef7e&scoped=true&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e6ef7e"]])

export default __exports__